// Core
import {Link, Route, Switch, Redirect, useRouteMatch, useLocation} from 'react-router-dom';

// Chakra imports
import {
    Box,
    Flex,
    Text,
    useColorModeValue
} from '@chakra-ui/react';

// Components
import Team from './team';
import Roles from './roles/Roles.js';
import RoleEdit from './roles/RoleEdit.js';
import usePermissionStatusByKey from '../../../hooks/usePermissionStatusByKey';
import useAccessibleEndpointsByGroups from '../../../hooks/useAccessibleEndpointsByGroups';


function Permissions({dataUser, tabEndpoints}) {
    const {path, url} = useRouteMatch();

    const location = useLocation();
    const isActive = (path) => location.pathname.includes(path);

    const textColor = useColorModeValue('blue.800', 'white');

    const isCapabilities = usePermissionStatusByKey('GET:/admin/roles/capabilities');
    const isRole = usePermissionStatusByKey('GET:/admin/roles/:id');

    const availableTabs = useAccessibleEndpointsByGroups(tabEndpoints);
    return (
        <>
            <Text
                fontSize="40px"
                fontStyle="normal"
                fontWeight="700"
                color={textColor}
                mb="12px"
            >
                Management Team
            </Text>
            <Box mt="0px" mb="50px" direction="column">
                <Flex
                    align="left"
                    mb={{sm: '10px', md: '0px'}}
                    direction={{sm: 'column', md: 'row'}}
                    w={{sm: '100%'}}
                    textAlign={{sm: 'center', md: 'start'}}
                    borderBottom="1px"
                    borderColor="rgba(255, 255, 255, 0.10)"
                    className="settings-tabs"
                >
                    {availableTabs.includes('/') && (
                        <Link
                            to={`${url}`}
                            className={
                                location.pathname === '/permissions'
                                    ? 'settings-tab-active'
                                    : ''
                            }
                        >
                            Team
                        </Link>
                    )}
                    {availableTabs.includes('/roles') && (
                        <Link
                            to={`${url}/roles`}
                            className={isActive(`${path}/roles`) ? 'settings-tab-active' : ''}
                        >
                            Roles
                        </Link>
                    )}
                </Flex>

                <Box align="left" mt="32px">
                    <Switch>
                        {(isCapabilities || isRole) && (
                            <Route
                                path={`${path}/roles/:id`}
                                render={() => <RoleEdit dataUser={dataUser}/>}
                            />
                        )}
                        {availableTabs.includes('/roles') && (
                            <Route
                                path={`${path}/roles`}
                                render={() => <Roles dataUser={dataUser}/>}
                            />
                        )}
                        {availableTabs.includes('/') && <Route path={`${path}`} render={() => <Team/>}/>}
                        <Redirect from={`${path}*`} to={`${path}${availableTabs[0]}`}/>
                    </Switch>
                </Box>
            </Box>
        </>
    );
}

export default Permissions;